export enum PaymentStatusEnum {
    PAID = "PAID",
    SUCCEEDED = "SUCCEEDED",
    PENDING = "PENDING"
};